function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.885 7.593h46.764v42.414H4.885zM2.71 3.243h51.113v4.35H2.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.71 50.007h51.113v4.35H2.71z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M27.179 7.593v14.138h-2.753c-.254.742-.503 1.47-.781 2.175h3.534v26.101h2.175v-26.1h3.535c-.279-.706-.528-1.434-.782-2.176h-2.753V7.593z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.179 7.593c-2.605 16.738-7.656 29.071-20.119 31.28 1.417 5.804 3.017 9.812 4.894 11.134H7.06V7.593zM29.354 7.593c2.605 16.738 7.656 29.071 20.119 31.28-1.417 5.804-3.018 9.812-4.894 11.134h4.894V7.593z"
})));

var SvgWindow = function SvgWindow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWindow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Window.9416a3f6.svg";
export { ForwardRef as ReactComponent };